import {Group, isGroup} from '@wandb/weave/common/util/data';

import {Tile} from './types';

export function getNonEmptyTileCount(tileOrGroup: Tile | Group<Tile>): number {
  if (!isGroup(tileOrGroup)) {
    return tileOrGroup.isEmpty ? 0 : 1;
  }

  let count = 0;
  for (const tile of tileOrGroup.items) {
    if (!tile.isEmpty) {
      count++;
    }
  }
  return count;
}
